export const fallbackData = {
  settings: {
    siteName: "Websites by BPA Solutions",
    primaryCta: "Request Similar",
    contactEmail: "hello@bpasolutions.au"
  },
  websiteReferences: [
    {
      websiteId: "ref-001",
      active: true,
      featured: true,
      featuredRank: 1,
      displayPriority: 10,
      publicTitle: "Premium Plumbing Group",
      businessType: "Trades",
      primaryCategory: "Trades",
      tags: ["Plumbing", "Quote System", "Local SEO"],
      outcomeType: "Lead Generation",
      location: "Sydney, NSW",
      imageUrl: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=800&auto=format&fit=crop&q=80",
      heroImageUrl: "",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "plumber construction pipe quote fast",
    },
    {
      websiteId: "ref-002",
      active: true,
      featured: true,
      featuredRank: 2,
      displayPriority: 20,
      publicTitle: "Apex Pest Management",
      businessType: "Local Services",
      primaryCategory: "Local Services",
      tags: ["Pest Control", "Automated Booking", "SMS Follow-up"],
      outcomeType: "Booking-Based",
      location: "Brisbane, QLD",
      imageUrl: "https://images.unsplash.com/photo-1536882240095-0379873feb4e?w=800&auto=format&fit=crop&q=80",
      heroImageUrl: "",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "pest control bug spray inspection",
    },
    {
      websiteId: "ref-003",
      active: true,
      featured: true,
      featuredRank: 3,
      displayPriority: 30,
      publicTitle: "Luxe Mortgage Consultants",
      businessType: "Professional Services",
      primaryCategory: "Professional Services",
      tags: ["Finance", "Client Portal", "Lead Capture"],
      outcomeType: "Lead Generation",
      location: "Melbourne, VIC",
      imageUrl: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&auto=format&fit=crop&q=80",
      heroImageUrl: "",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "mortgage broker finance consultant loan",
    },
    {
      websiteId: "ref-004",
      active: true,
      featured: true,
      featuredRank: 4,
      displayPriority: 40,
      publicTitle: "Paws & Walk",
      businessType: "Booking-Based Services",
      primaryCategory: "Booking-Based",
      tags: ["Dog Walking", "Schedule Integration", "Payments"],
      outcomeType: "Booking-Based",
      location: "Perth, WA",
      imageUrl: "https://images.unsplash.com/photo-1601758228041-f3b279ce7ae6?w=800&auto=format&fit=crop&q=80",
      heroImageUrl: "",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "dog walking pet care sitter",
    },
    {
      websiteId: "ref-005",
      active: true,
      featured: true,
      featuredRank: 5,
      displayPriority: 50,
      publicTitle: "Aura Fine Jewellery",
      businessType: "Product Showcase",
      primaryCategory: "Product Showcase",
      tags: ["Retail", "Inventory Sync", "Premium Visual"],
      outcomeType: "Product Showcase",
      location: "Adelaide, SA",
      imageUrl: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800&auto=format&fit=crop&q=80",
      heroImageUrl: "",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "ring necklace retail luxury store",
    },
    {
      websiteId: "ref-006",
      active: true,
      featured: true,
      featuredRank: 6,
      displayPriority: 60,
      publicTitle: "CareLink NDIS Connect",
      businessType: "Automation-Led System",
      primaryCategory: "Automation Systems",
      tags: ["NDIS", "Compliance Forms", "Dashboards"],
      outcomeType: "Automation Systems",
      location: "National",
      imageUrl: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&auto=format&fit=crop&q=80",
      heroImageUrl: "",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "ndis healthcare support forms automation",
    },
    {
      websiteId: "ref-007",
      active: true,
      featured: false,
      featuredRank: 99,
      displayPriority: 70,
      publicTitle: "Elite Construction Co",
      businessType: "Trades",
      primaryCategory: "Trades",
      tags: ["Building", "Project Gallery", "Quote Form"],
      outcomeType: "Lead Generation",
      location: "Sydney, NSW",
      imageUrl: "",
      heroImageUrl: "https://images.unsplash.com/photo-1541888086425-d81bb19240f5?w=800&auto=format&fit=crop&q=80",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "construction builder house trade",
    },
    {
      websiteId: "ref-008",
      active: true,
      featured: false,
      featuredRank: 99,
      displayPriority: 80,
      publicTitle: "Sparkle Cleaning Solutions",
      businessType: "Local Services",
      primaryCategory: "Local Services",
      tags: ["Cleaning", "Instant Quote", "Staff Roster"],
      outcomeType: "Automation Systems",
      location: "Melbourne, VIC",
      imageUrl: "",
      heroImageUrl: "",
      websiteUrl: "",
      previewUrl: "",
      searchKeywords: "cleaning house office commercial",
    }
  ],
  seoLocations: [
    {
      active: true,
      sortOrder: 1,
      state: "NSW",
      displayGroup: "East Coast",
      region: "Greater Sydney",
      introCopy: "Providing website systems designed to capture local Sydney enquiries efficiently.",
      aeoQuestion: "What makes a local service website effective in Sydney?",
      aeoAnswer: "An effective Sydney local service website combines fast loading speeds, localized SEO structure, and automated enquiry capture to respond to customers before competitors do."
    },
    {
      active: true,
      sortOrder: 2,
      state: "QLD",
      displayGroup: "East Coast",
      region: "Brisbane & Gold Coast",
      introCopy: "High-performance website references developed for fast-moving Queensland businesses.",
      aeoQuestion: "How do automated website systems help trades in Brisbane?",
      aeoAnswer: "By capturing lead details directly into connected enquiry records and triggering instant SMS responses, Brisbane trades can secure jobs while still on site."
    }
  ],
  footerLinks: [
    { active: true, sortOrder: 1, category: "Website Systems", title: "Trade Website References", url: "#trades" },
    { active: true, sortOrder: 2, category: "Website Systems", title: "Local Service Website References", url: "#local" },
    { active: true, sortOrder: 3, category: "Resources", title: "Automation Platforms", url: "#automation" },
    { active: true, sortOrder: 4, category: "Resources", title: "Free SEO Guide", url: "#seo-guide" },
    { active: true, sortOrder: 5, category: "Company", title: "Contact BPA Solutions", url: "#contact" }
  ]
};